// Hero slideshow slider js

document.addEventListener('DOMContentLoaded', function () {
  var herosliderSwipers = [];

  function initherosliderSwiper(swiperContainer) {
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;
      var slider = swiperContainer.dataset.slider;

      var herosliderSwiper = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          navigation: {
              nextEl: swiperContainer.querySelector(".slider-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".slider-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".slider-swiper-pagination"),
              clickable: true,
          }
      });

      // Hover par autoplay stop and start functionality
      swiperContainer.addEventListener('mouseenter', function () {
          herosliderSwiper.autoplay.stop();  // Hover karta autoplay stop
      });

      swiperContainer.addEventListener('mouseleave', function () {
          herosliderSwiper.autoplay.start();  // Mouse hata pachhi autoplay start
      });

      herosliderSwipers.push(herosliderSwiper);
  }

  // Initialize Hero slider Swiper on page load
  document.querySelectorAll('.classic-container').forEach(function (swiperContainer) {
      initherosliderSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Hero slider Swiper on section select
      herosliderSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      herosliderSwipers = [];
      document.querySelectorAll('.classic-container').forEach(function (swiperContainer) {
          initherosliderSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Hero slider Swiper on section deselect if necessary
      herosliderSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      herosliderSwipers = [];
  });
});

// Image banner text slider js

document.addEventListener('DOMContentLoaded', function () {
  var ImageBannerTextSwipers = [];

  function initImageBannerTextSwiper(swiperContainer) {
      var slider = swiperContainer.dataset.slider;

      var ImageBannerTextSwiper = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: false,
          autoplay: false,
          speed: 500,
          grabCursor: false,
          navigation: false,
          pagination: false
      });
  }

  // Initialize Hero slider Swiper on page load
  document.querySelectorAll('.image-banner-text-section-wrapper').forEach(function (swiperContainer) {
      initImageBannerTextSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Hero slider Swiper on section select
      ImageBannerTextSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      ImageBannerTextSwipers = [];
      document.querySelectorAll('.image-banner-text-section-wrapper').forEach(function (swiperContainer) {
          initImageBannerTextSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Hero slider Swiper on section deselect if necessary
      ImageBannerTextSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      ImageBannerTextSwipers = [];
  });
});

// Banner with product slider js

document.addEventListener('DOMContentLoaded', function () {
  var BannerwithproductSwipers = [];

  function initBannerwithproductSwiper(swiperContainer) {
      var speed = swiperContainer.dataset.speed;
      var slider = swiperContainer.dataset.slider;

      var BannerwithproductSwiper = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: false,
          autoplay: false,
          speed: speed,
          simulateTouch: false,
          allowTouchMove: false,
          touchStartPreventDefault: false,
          grabCursor: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".banner-with-product-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".banner-with-product-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".banner-with-product-swiper-pagination"),
              clickable: true,
              type: 'fraction',
              renderFraction: function (currentClass, totalClass) {
                  return '<span class="' + currentClass + '"></span>' +
                         ' / ' +
                         '<span class="' + totalClass + '"></span>';
              }
          },
          on: {
              slideChange: function () {
                  this.pagination.update(); 
              }
          }
      });
  }

  // Initialize Hero slider Swiper on page load
  document.querySelectorAll('.banner-with-product-container').forEach(function (swiperContainer) {
      initBannerwithproductSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Hero slider Swiper on section select
      BannerwithproductSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      BannerwithproductSwipers = [];
      document.querySelectorAll('.banner-with-product-container').forEach(function (swiperContainer) {
          initBannerwithproductSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Hero slider Swiper on section deselect if necessary
      BannerwithproductSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      BannerwithproductSwipers = [];
  });
});

// featured collection slider js

document.addEventListener('DOMContentLoaded', function () {
  var FeaturedcollectionSwipers = [];

  function initFeaturedcollectionSwiper(swiperContainer) {
      var enable = swiperContainer.dataset.enable;
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

    if (enable) {
      var FeaturedcollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".featured-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".featured-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".featured-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace
            },
        },
      });

      // Add hover functionality to stop and start autoplay
      swiperContainer.addEventListener('mouseenter', function () {
          FeaturedcollectionSwiper.autoplay.stop();  // Autoplay stops on hover
      });

      swiperContainer.addEventListener('mouseleave', function () {
          FeaturedcollectionSwiper.autoplay.start();  // Autoplay resumes after hover
      });

      FeaturedcollectionSwipers.push(FeaturedcollectionSwiper);
    }
  }

  // Initialize Featured collection Swiper on page load
  document.querySelectorAll('.featured-slider').forEach(function (swiperContainer) {
      initFeaturedcollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Featured collection Swiper on section select
      FeaturedcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      FeaturedcollectionSwipers = [];
      document.querySelectorAll('.featured-slider').forEach(function (swiperContainer) {
          initFeaturedcollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Featured collection Swiper on section deselect if necessary
      FeaturedcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      FeaturedcollectionSwipers = [];
  });
});

// tab collection slider js

document.addEventListener('DOMContentLoaded', function () {
  var TabcollectionSwipers = [];

  function initTabcollectionSwiper(swiperContainer) {
      var enable = swiperContainer.dataset.enable;
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

    if (enable) {
      var TabcollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".tab-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".tab-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".tab-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace
            },
        },
      });

      // Add hover functionality to stop and start autoplay
      swiperContainer.addEventListener('mouseenter', function () {
          TabcollectionSwiper.autoplay.stop();  // Stop autoplay on hover
      });

      swiperContainer.addEventListener('mouseleave', function () {
          TabcollectionSwiper.autoplay.start();  // Resume autoplay after hover
      });

      TabcollectionSwipers.push(TabcollectionSwiper);
    }
  }

  // Initialize Tab collection Swiper on page load
  document.querySelectorAll('.tab-slider').forEach(function (swiperContainer) {
      initTabcollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Tab collection Swiper on section select
      TabcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      TabcollectionSwipers = [];
      document.querySelectorAll('.tab-slider').forEach(function (swiperContainer) {
          initTabcollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Tab collection Swiper on section deselect if necessary
      TabcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      TabcollectionSwipers = [];
  });
});

// category collection slider

document.addEventListener('DOMContentLoaded', function () {
  var categorycollection1Swipers = [];

  function initcategorycollection1Swiper(swiperContainer) {
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var categorycollection1Swiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 12,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".category-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".category-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".category-swiper-pagination"),
              clickable: true,
          },
          breakpoints : {
            320: {
                slidesPerView: mobile,
                spaceBetween: 6,
            },
            480: {
                slidesPerView: tablet,
                spaceBetween: 6,
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: 6,
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: 6,
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: 12,
            },
            1200: {
                slidesPerView: desktop,
                spaceBetween: 12,
            },
          }
      });

      categorycollection1Swipers.push(categorycollection1Swiper);
  }

  // Initialize category collection Swiper on page load
  document.querySelectorAll('.main-collections-list-wrapper').forEach(function (swiperContainer) {
      initcategorycollection1Swiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize category collection Swiper on section select
      categorycollection1Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      categorycollection1Swipers = [];
      document.querySelectorAll('.main-collections-list-wrapper').forEach(function (swiperContainer) {
          initcategorycollection1Swiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup category collection Swiper on section deselect if necessary
      categorycollection1Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      categorycollection1Swipers = [];
  });
});

// Subcategory collection slider

document.addEventListener('DOMContentLoaded', function () {
  var subcategorycollectionSwipers = [];

  function initsubcategorycollectionSwiper(swiperContainer) {
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay;
      var loop = swiperContainer.dataset.loop;
      var speed = swiperContainer.dataset.speed;
  
      var slidesCount = swiperContainer.querySelectorAll('.swiper-slide').length;
  
      var centeredSlidesSetting = slidesCount <= 6;
  
      var subcategorycollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 80,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          centeredSlides: centeredSlidesSetting,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".subcategory-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".subcategory-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".subcategory-swiper-pagination"),
              clickable: true,
          },
          breakpoints : {
            320: {
                slidesPerView: mobile,
                spaceBetween: 40,
                centeredSlides: true,
            },
            480: {
                slidesPerView: tablet,
                spaceBetween: 40,
                centeredSlides: true,
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: 40,
                centeredSlides: true,
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: 40,
                centeredSlides: true,
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: 80,
                centeredSlides: true,
            },
            1200: {
                slidesPerView: desktop,
                spaceBetween: 80,
                centeredSlides: true,
            },
          }
      });
  
      subcategorycollectionSwipers.push(subcategorycollectionSwiper);
  }

  // Initialize category collection Swiper on page load
  document.querySelectorAll('.main-subcollections-list-wrapper').forEach(function (swiperContainer) {
      initsubcategorycollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize category collection Swiper on section select
      subcategorycollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      subcategorycollectionSwipers = [];
      document.querySelectorAll('.main-subcollections-list-wrapper').forEach(function (swiperContainer) {
          initsubcategorycollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup category collection Swiper on section deselect if necessary
      subcategorycollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      subcategorycollectionSwipers = [];
  });
});

// Best selling collection slider js

document.addEventListener('DOMContentLoaded', function () {
  var BestsellingcollectionSwipers = [];

  function initBestsellingcollectionSwiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var BestsellingcollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".bestselling-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".bestselling-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".bestselling-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace
            },
          },
      });

      // Add hover functionality to stop and start autoplay
      swiperContainer.addEventListener('mouseenter', function () {
          BestsellingcollectionSwiper.autoplay.stop();  // Stop autoplay on hover
      });

      swiperContainer.addEventListener('mouseleave', function () {
          BestsellingcollectionSwiper.autoplay.start();  // Resume autoplay after hover
      });

      BestsellingcollectionSwipers.push(BestsellingcollectionSwiper);
  }

  // Initialize Bestselling collection Swiper on page load
  document.querySelectorAll('.bestselling-slider').forEach(function (swiperContainer) {
      initBestsellingcollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Bestselling collection Swiper on section select
      BestsellingcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      BestsellingcollectionSwipers = [];
      document.querySelectorAll('.bestselling-slider').forEach(function (swiperContainer) {
          initBestsellingcollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Bestselling collection Swiper on section deselect if necessary
      BestsellingcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      BestsellingcollectionSwipers = [];
  });
});

// blog slider js

document.addEventListener('DOMContentLoaded', function () {
  var FeaturedblogSwipers = [];

  function initFeaturedblogSwiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;
  
      var FeaturedblogSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".blog-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".blog-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".blog-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace
            },
        },
      });

      // Add hover functionality to stop and start autoplay
      swiperContainer.addEventListener('mouseenter', function () {
          FeaturedblogSwiper.autoplay.stop();  // Stop autoplay on hover
      });

      swiperContainer.addEventListener('mouseleave', function () {
          FeaturedblogSwiper.autoplay.start();  // Resume autoplay after hover
      });

      FeaturedblogSwipers.push(FeaturedblogSwiper);
  }

  // Initialize Featured blog Swiper on page load
  document.querySelectorAll('.blog-slider').forEach(function (swiperContainer) {
      initFeaturedblogSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Featured blog Swiper on section select
      FeaturedblogSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      FeaturedblogSwipers = [];
      document.querySelectorAll('.blog-slider').forEach(function (swiperContainer) {
          initFeaturedblogSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Featured blog Swiper on section deselect if necessary
      FeaturedblogSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      FeaturedblogSwipers = [];
  });
});

// multicolumn slider js

document.addEventListener('DOMContentLoaded', function () {
  var MulticolumnSwipers = [];

  function initmulticolumnSwiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var MulticolumnSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          centeredSlides: true,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".multicolumn-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".multicolumn-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".multicolumn-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace
            },
          },
      });

      // Add hover functionality to stop and start autoplay
      swiperContainer.addEventListener('mouseenter', function () {
          MulticolumnSwiper.autoplay.stop();  // Stop autoplay on hover
      });

      swiperContainer.addEventListener('mouseleave', function () {
          MulticolumnSwiper.autoplay.start();  // Resume autoplay after hover
      });

      MulticolumnSwipers.push(MulticolumnSwiper);
  }

  // Initialize Multicolumn Swiper on page load
  document.querySelectorAll('.multicolumn-slider').forEach(function (swiperContainer) {
      initmulticolumnSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Multicolumn Swiper on section select
      MulticolumnSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      MulticolumnSwipers = [];
      document.querySelectorAll('.multicolumn-slider').forEach(function (swiperContainer) {
          initmulticolumnSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Multicolumn Swiper on section deselect if necessary
      MulticolumnSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      MulticolumnSwipers = [];
  });
});

// video product slider js

document.addEventListener('DOMContentLoaded', function () {
  var VideoproductSwipers = [];

  function initVideoproductSwiper(swiperContainer) {
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var VideoproductSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 12,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".videoproduct-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".videoproduct-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".videoproduct-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: 6
            },
            480: {
                slidesPerView: tablet,
                spaceBetween: 6
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: 6
            },
            992: {
                slidesPerView: largeTablet,
                spaceBetween: 12
            },
            1200: {
                slidesPerView: desktop,
                spaceBetween: 12
            }
        },
      });

      // Add hover functionality to stop and start autoplay
      swiperContainer.addEventListener('mouseenter', function () {
          VideoproductSwiper.autoplay.stop();  // Stop autoplay on hover
      });

      swiperContainer.addEventListener('mouseleave', function () {
          VideoproductSwiper.autoplay.start();  // Resume autoplay after hover
      });

      VideoproductSwipers.push(VideoproductSwiper);
  }

  // Initialize Videoproduct collection Swiper on page load
  document.querySelectorAll('.video-product-slider').forEach(function (swiperContainer) {
      initVideoproductSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Videoproduct collection Swiper on section select
      VideoproductSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      VideoproductSwipers = [];
      document.querySelectorAll('.video-product-slider').forEach(function (swiperContainer) {
          initVideoproductSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Videoproduct collection Swiper on section deselect if necessary
      VideoproductSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      VideoproductSwipers = [];
  });
});

// Team stories slider js

document.addEventListener('DOMContentLoaded', function () {
  var TeamstoriesSwipers = [];

  function initTeamstoriesSwiper(swiperContainer) {
      var TeamstoriesSwiper = new Swiper(swiperContainer, {
          spaceBetween: 0,
          slidesPerView: 1.6,
          centeredSlides: true,
          loop: true,
          grabCursor: true,
          a11y: false,
          navigation: false,
          pagination: false,
          autoplay: false,
          breakpoints: {
            320: {
                slidesPerView: 1.3,
                spaceBetween: 0
            },
            480: {
                slidesPerView: 1.4,
                spaceBetween: 0
            },
            841: {
                slidesPerView: 1.5,
                spaceBetween: 0
            },
            992: {
                slidesPerView: 1.6,
                spaceBetween: 0
            },
        },
      });

      // Stop autoplay on hover
      swiperContainer.addEventListener('mouseenter', function () {
          TeamstoriesSwiper.autoplay.stop();
      });

      swiperContainer.addEventListener('mouseleave', function () {
          TeamstoriesSwiper.autoplay.start();
      });

      TeamstoriesSwipers.push(TeamstoriesSwiper);
  }

  // Initialize all sliders
  document.querySelectorAll('.video-stories-slider').forEach(function (swiperContainer) {
      initTeamstoriesSwiper(swiperContainer);
  });

  // Reinitialize on Shopify section select
  document.addEventListener('shopify:section:select', function () {
      TeamstoriesSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      TeamstoriesSwipers = [];
      document.querySelectorAll('.video-stories-slider').forEach(function (swiperContainer) {
          initTeamstoriesSwiper(swiperContainer);
      });
  });

  // Destroy on section deselect
  document.addEventListener('shopify:section:deselect', function () {
      TeamstoriesSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      TeamstoriesSwipers = [];
  });
});

// recentview collection slider js

document.addEventListener('DOMContentLoaded', function () {
  var recentviewcollectionSwipers = [];

  function initrecentviewcollectionSwiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay;
      var loop = swiperContainer.dataset.loop;
      var speed = swiperContainer.dataset.speed;


      var recentviewcollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".recent-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".recent-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".recent-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace
            },
        },
      });

      recentviewcollectionSwipers.push(recentviewcollectionSwiper);
  }

  // Initialize Featured collection Swiper on page load
  document.querySelectorAll('.recent-slider').forEach(function (swiperContainer) {
      initrecentviewcollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Featured collection Swiper on section select
      recentviewcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      recentviewcollectionSwipers = [];
      document.querySelectorAll('.recent-slider').forEach(function (swiperContainer) {
          initrecentviewcollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Featured collection Swiper on section deselect if necessary
      recentviewcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      recentviewcollectionSwipers = [];
  });
});

// PLP Banner slider js

document.addEventListener('DOMContentLoaded', function () {
  var collectionBannerSliderSwipers = [];

  function initcollectionBannerSliderSwiper(swiperContainer) {
      var collectionBannerSliderSwiper = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          autoplay: true,
          speed: 500,
          grabCursor: true,
          navigation: false,
          pagination: {
              el: swiperContainer.querySelector(".collection-main-banner-slider-swiper-pagination"),
              clickable: true,
          }
      });

      // Hover par autoplay stop and start functionality
      swiperContainer.addEventListener('mouseenter', function () {
          collectionBannerSliderSwiper.autoplay.stop();  // Hover karta autoplay stop
      });

      swiperContainer.addEventListener('mouseleave', function () {
          collectionBannerSliderSwiper.autoplay.start();  // Mouse hata pachhi autoplay start
      });

      collectionBannerSliderSwipers.push(collectionBannerSliderSwiper);
  }

  // Initialize Hero slider Swiper on page load
  document.querySelectorAll('.collection-main-banner-slider-inner').forEach(function (swiperContainer) {
      initcollectionBannerSliderSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Hero slider Swiper on section select
      collectionBannerSliderSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      collectionBannerSliderSwipers = [];
      document.querySelectorAll('.collection-main-banner-slider-inner').forEach(function (swiperContainer) {
          initcollectionBannerSliderSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Hero slider Swiper on section deselect if necessary
      collectionBannerSliderSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      collectionBannerSliderSwipers = [];
  });
});